export default "__VITE_ASSET__Cul1pe_4__"